// @codekit-prepend "../ext/jquery/jquery.js"
// @codekit-prepend "../ext/bower_components/bootstrap/dist/js/bootstrap.js"
// @codekit-prepend "../ext/bower_components/slick-carousel/slick/slick.js"
// @codekit-prepend "../ext/cropper-2.3.0/dist/cropper.min.js"
// @codekit-prepend "../mlib/js/form-extras.js"

//! Skrollaa parametrina annetun id:n kohdalle

function scrollToAnchor(linkId) {
    var aTag = $(linkId);
    $('html, body').animate({ scrollTop: aTag.offset().top }, 'slow');
}


$(function() {

	// Klikattaessa toimitusosoitteita, täytetään toimitusosoite-formi
	$(".previous_shipping_addresses a").on('click', function(e) {
		$(this).find(".fill").each(function(i, obj) {
			var target = $(obj).data("target");
			var value = $(obj).text();
			if (target !== undefined) {
				$("#checkout_shipping_details [name="+target+"]").val(value);
			}
		});

		e.preventDefault();
	});




	// Lisätään toimitusosoitteen tyhjennysnappi
	$(".previous_shipping_addresses .list-group").append('<a href="#" class="list-group-item" id="clear_shipping_address">Tyhjennä toimitusosoite</a>');


	// Klikattaessa toimitusosoitteita, täytetään toimitusosoite-formi
	$("#clear_shipping_address").click(function(e) {
		clear_form_elements("#checkout_shipping_details");
		e.preventDefault();
	});


	// Skrollaus halutun elementin kohdalle (ks. funktio scrollToAnchor)
	$('[data-show-element]').each(function() {
		var $this = $(this);
		$this.on('click', function() {
			var show_element_id = '#' + $this.data('showElement');
			$(show_element_id).show();
			scrollToAnchor(show_element_id);
		});
	});

	$('a[data-scroll-to]').on('click', function() {
	    scrollToAnchor($(this).prop('hash'));
	});


	// Tuotehaitarin nuolet
	$('.product__panel .collapse').on('shown.bs.collapse', function() {
		$(this).parent().find(".fa-caret-right").removeClass("fa-caret-right").addClass("fa-caret-down");
	}).on('hidden.bs.collapse', function() {
		$(this).parent().find(".fa-caret-down").removeClass("fa-caret-down").addClass("fa-caret-right");
	});


	// Ostoskorin nappuloiden piilotus ja näyttäminen
	$('#update_cart').hide();

	// Kertaluontoisesti swapataan buttoni, kun jokin input muuttuu
	$('#checkout_products').one('input.updatecart change.updatecart', ':input', function() {
		$('#cart_confirm').hide();
		$('#update_cart').show();
	});


	// Ostoskorin päivitys nappulaa painettaessa
	$("#update_cart").on('click', function(e) {
		e.preventDefault();
		var $form = $(this).parents('form:first');
		$.ajax({
			type: "POST",
			url: $form.attr("action"),
			data: $form.serialize(), // serializes the form's elements.
			success: function() {
				window.location = $form.attr("action");
			}
		});
	});


	// Login / Password forgotten switcher
	$(".user-login__password-forgotten").hide();
	$('a[data-toggle="password_forgotten"]').removeClass("hidden");
		
	$('a[data-toggle="password_forgotten"]').click(function(e) {
		e.preventDefault();
		if ($(".user-login__password-forgotten").is(":visible")) {
			$(".user-login__login").show();
			$(".user-login__password-forgotten").hide();
		}
		else {
			$(".user-login__login").hide();
			$(".user-login__password-forgotten").show();
		}
	});
	
	$('#login').on('hidden.bs.modal', function () {
		$(".user-login__login").show();
		$(".user-login__password-forgotten").hide();
	});



	// Mobiilikoossa tuotenimi siirretään kuvan yläpuolelle
	function change_product_heading_position() {
		if ($(window).width() < 768) {
			$('.product__name').prependTo('.product__image-wrapper');
		} else {
			$('.product__name').prependTo('.product__actions-wrapper');
		}
	}

	change_product_heading_position();


	$('#sku_select').on('change', function() {
		var optionSelected = $("option:selected", this);
		$(".product__price-value").html(optionSelected.data("price"));
		disable_add_to_cart_button();
	});

	function disable_add_to_cart_button() {
		if ($('#sku_select') ) {
			if ($('#sku_select').val() === '') {
				$('#product_add_to_cart').attr('disabled', 'disabled');
			}
			else {
				$('#product_add_to_cart').removeAttr('disabled');
			}
		}
	}

	disable_add_to_cart_button();

	// Ikkunan kokoa muutettaessa ajettavat skriptit
	$(window).resize(function() {
		change_product_heading_position();
	});

	// // Navbar tiiviimmäksi, kun skrollataan alaspäin
	// $(window).on('scroll', function() {
	// 	if ($(window).width() > 767) {
	// 		var fromTop = $(document).scrollTop();
	// 		if (fromTop >= 90) {
	// 			$('body').addClass('scrolled');
	// 			$('.logo__block').addClass('hidden');
	// 		} else {
	// 			$('body').removeClass('scrolled');
	// 			$('.logo__block').removeClass('hidden');
	// 		}
	// 	}
	// });

	$('.slideshow__slides').slick({
		arrows: true,
		autoplay: true,
		autoplaySpeed: 4000,
		centerMode: true,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 2,
		variableWidth: true
	});

	$('.spotlight__carousel').slick({
		arrows: true,
		autoplay: false,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1
	});

	$('.product__thumbnails--horizontal').slick({
		arrows: true,
		dots: false,
		infinite: false,
		slidesToShow: 6,
		slidesToScroll: 6,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            }
        ]
	});

	$('.product__thumbnails--vertical').slick({
		vertical: true,
		verticalSwiping: true,
		arrows: true,
		infinite: false,
		slidesToShow: 3,
		slidesToScroll: 3,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					vertical: false,
					verticalSwiping: false,
					arrows: true,
                    dots: false,
					slidesToShow: 4,
					slidesToScroll: 4
				}
			}
		]
	});


    var get_breakpoint = function(_target) {
        var breakpoints = ['300', '500', '700'];
        var min_bp = Number.MAX_VALUE;
        var target_int = parseInt(_target);
        var min_res = Number.MAX_VALUE;

        for (i in breakpoints) {
            var result = Math.abs(target_int - parseInt(breakpoints[i]));
            if (result < min_res) {
                min_bp = breakpoints[i];
                min_res = result;
            }
        }

        return min_bp;
    };

    // Muuttujat joita tämä scripti käytää. Eli mikä tieto löytyy mistäkin
    var cropperData = {
        image: $(".cropper-source > img"), 
        preview: $("#cropper-preview"), 
        dataX: $("#image_start_x"),
        dataY: $("#image_start_y"),
        dataHeight: $("#image_height"),
        dataWidth: $("#image_width"),
        wallWidth: $('#wall_width'),
        wallHeight: $('#wall_height'),
    };


    // Init tominnallisuudet
    // nämä ajetaan vain kerran, silloin kun sivu ladataan

    // Ladattaessa sivu, määritellään preview elementille koko (cropper työkalu vaatii)
    cropperData.preview.css({
       'width' : cropperData.preview.parent().width(),
       'height' : cropperData.preview.parent().width(),
       'overflow' : 'hidden'
    });

    // Aluksi luodaan cropper (mikäli cropper löytyy)           
    cropperData.image.cropper({
        data: {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        },
        preview: cropperData.preview,
        crop: function(data) {
            cropperData.dataX.val(Math.round(data.x));
            cropperData.dataY.val(Math.round(data.y));
            cropperData.dataHeight.val(Math.round(data.height));
            cropperData.dataWidth.val(Math.round(data.width));
        },
        cropend: function() {
            validate_wall_size();
        },
        guides: false,
        zoomable: false,
        cropBoxResizable: true,
        built: function() {
            updateCropBoxSize();
            data = cropperData.image.cropper('getData');
            cropperData.dataX.val(Math.round(data.x));
            cropperData.dataY.val(Math.round(data.y));
            cropperData.dataHeight.val(Math.round(data.height));
            cropperData.dataWidth.val(Math.round(data.width));
            validate_wall_size();
        },
        checkImageOrigin: false,
        autoCropArea: 1.0,
        minCropBoxWidth: 20,
        minCropBoxHeight: 20
    });
        

    // Ajonaikaiset toiminnallisuudet. 
    // Tässä määritellään mitä tapahtuu kun esim. formi muuttuu tai klikataan jotain elementtiä

    
    update_model_rooms($("input#wall_width").val());

    // Kun tapetin leveys muuttuu, päivitetään mahdollisesti huonekuvat
    $('input#wall_width').on('keyup', function() {
        update_model_rooms($(this).val());
    });

    function update_model_rooms(wall_width) {
        var old_breakpoint = $('.product__thumbnail').first().data('width');
        var new_breakpoint = get_breakpoint(wall_width);

        $(".product__thumbnails--horizontal").slick('slickUnfilter');
        $(".product__thumbnails--horizontal").slick('slickFilter','[data-width="'+new_breakpoint+'"]');

        $('[data-room]').on('click', function(e) {
            e.preventDefault();
            var room_src = $(this).data('room');
            $('#room-preview').attr('src', room_src);
        });

        if (old_breakpoint != new_breakpoint) {
            var new_src = $('.slick-track .product__thumbnail-link').first().data('room');
            $('#room-preview').attr('src', new_src);
        }
    }

    // Kun tapetin koko muuttuu...
    $('input#wall_width, input#wall_height').on('keyup', function() {
        // Lasketaan hinta uudelleen...
        calculatePrice();
        // Lasketaan CropBox / preview image uudelleen.
        updateCropBoxSize();
        // Tarkistetaan, että kuvasta saa tehtyä riittävän ison
        validate_wall_size();
    });

    // Kun materiaali muuttuu...
    $('input[name="material"]').on('change', function() {
        // Lasketaan hinta uudelleen...
        calculatePrice();
    });
    
    // Taustakuvan vaihto
    // Klikattaessa elementtiä joilla on data-room attribuutti, vaihdetaan kuva arvon mukaiseksi
    // Esim. jos data-room="kuvannimi.jpg",  vaihdetaan preview näkymään huone kuvaksi "kuvannimi.jpg"
    $('[data-room]').on('click', function(e) {
        e.preventDefault();
        var room_src = $(this).data('room');
        $('#room-preview').attr('src', room_src);
    });

    // Ladataan hover-kuvat valmiiksi, ettei tule viivettä hoveroidessa
    $('.gallery-list__link-wrapper[data-hover-image-url]').each(function() {
        $this = $(this);
        $.get($this.data('hover-image-url'));
    });

    // Vaihdetaan taustakuva hoverina
    $('.gallery-list__link-wrapper[data-hover-image-url]').hover(
        function() {
            $this = $(this);
            $original_background_image = $this.css('background-image');
            $this.css('background-image', 'url("' + $this.data('hover-image-url') + '")');
        }, function() {
            $this.css('background-image', $original_background_image);
        }
    );

    // Funktiot joita rajaustyökalu käyttää
    /**
     * calculatePrice
     * Laskee tuotttelle hinnan perustuen asiakkaan asettmiin arvoihin (tapetin korkeus ja leveys)
     * Tapetin neliöhinta tulee price -inputin data-attribuutista (data-price)
     * @return {void}
     */
    function calculatePrice() {
        $('.price-placeholder').hide();
        var wallpaperWidth = cropperData.wallWidth.val();
        var wallpaperHeight = cropperData.wallHeight.val();
        var price = $('input[name="material"]:checked').data('price');
        var royalty_price = $(".product-royalty__value").html();
        if (typeof royalty_price == 'undefined') {
            royalty_price = 0;
        }
        
        if (wallpaperWidth && wallpaperHeight && price) {
            var total_price = ((wallpaperWidth * wallpaperHeight * price) / 10000 + parseFloat(royalty_price));

            if (total_price < price) {
                total_price = price;
            }

            total_price = total_price.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            $('#total-price').text(total_price + ' €');

            $('#addToCart').prop('disabled', false);
        }
    }
            
    /**
     * updateCropBoxSize
     * Päivittää CropBoxin (se neliö mitä raahataan) / preview kuvan cropper työkalun arvojen muuaan
     * Preview simuloi valmista tapettia
     * Tätä kutsutaan:
     *   - Ladattaessa cropper script
     *   - Kun muutetaan cropper työkalulla rajausta
     *   - kun asiakas muuttaa seinän kokoa
     * @return {void}
     */
    function updateCropBoxSize() {

        // Seinän koko ja kuvasuhde lasketaan asiakkaan antamista mitoista (input-kentät)
        var wall_width = parseInt(cropperData.wallWidth.val(), 10);
        var wall_height = parseInt(cropperData.wallHeight.val(), 10);
        var wall_aspect_ratio = wall_width/wall_height;

        // console.log('Wall aspect ratio', wall_aspect_ratio);
        
        // Kuvatiedoston koko ja kuvasuhde haetaan alkuperäisen kuvan mitoista (cropper-objekti kertoo alkuperäisen tiedoston koon)
        var paper_naturalWidth = cropperData.image.cropper("getImageData").naturalWidth;
        var paper_naturalHeight = cropperData.image.cropper("getImageData").naturalHeight;
        var paper_aspect_ratio = paper_naturalWidth/paper_naturalHeight;

        // console.log('Paper aspect ratio', paper_aspect_ratio);
        
        var cropper_height, cropper_width;
        
        if (wall_aspect_ratio < paper_aspect_ratio) {
            // Jos on siis pystykuva, crop-boxin korkeus on kuvan korkeus, ja leveys lasketaan kuvasuhteen mukaan
            cropper_height = paper_naturalHeight;
            cropper_width = Math.floor(cropper_height*wall_aspect_ratio);
        }
        else {
            // Jos taas on vaakakuva, crop-boxin leveys on kuvan leveys, ja korkeus lasketaan kuvasuhteen mukaan
            cropper_width = paper_naturalWidth;
            cropper_height = Math.floor(cropper_width/wall_aspect_ratio);
        }

        // console.log('Cropper width', cropper_width);
        // console.log('Cropper height', cropper_height);

        // Esikatselukuvan leveys on tässä leiskassa aina vakio eli esikatselun leveys ei muutu...
        // Pitäisikö tähän tehdä vielä jokin maksimileveys / keskitys jottei kuva tule liian korkeaksi pystykuvissa???
        var preview_width = cropperData.preview.width();

        // Muutetaan esikatselukuvan korkeus lasketun kuvasuhteen mukaan.
        cropperData.preview.height(preview_width/wall_aspect_ratio);

        // Asetetaan uudet arvot Crop-boxille..
        cropperData.image.cropper("setData", {
            "width": cropper_width,
            "height": cropper_height
        });
        cropperData.image.cropper("setAspectRatio", wall_width/wall_height);
    }

    function validate_wall_size() {
        imagedata = cropperData.image.cropper("getImageData");
        // Leveys-kentän arvo
        var wall_width = parseInt(cropperData.wallWidth.val(), 10);
        // console.log('Valittu leveys', wall_width);
        // Korkeus-kentän arvo
        var wall_height = parseInt(cropperData.wallHeight.val(), 10);
        // console.log('Valittu korkeus', wall_height);
        // PHP:ssä laskettu kuvan maksimileveys
        var max_width = cropperData.wallWidth.data('max-width');
        // console.log('Tapettikuvan maksimileveys', max_width);
        // PHP:ssä laskettu kuvan maksimikorkeus
        var max_height = cropperData.wallHeight.data('max-height');
        // console.log('Tapettikuvan maksimikorkeus', max_height);
        // Cropperissa valitun alueen leveys pikseleinä (suhteessa _todelliseen_ kokoon)
        var cropper_width = parseInt(cropperData.dataWidth.val(), 10);
        // console.log('Crop-alueen leveys suhteessa alkuperäiseen', cropper_width);
        // Cropperissa valitun alueen korkeus pikseleinä (suhteessa _todelliseen_ kokoon)
        var cropper_height = parseInt(cropperData.dataHeight.val(), 10);
        // console.log('Crop-alueen korkeus suhteessa alkuperäiseen', cropper_height);
        // Alkuperäisen kuvan leveys
        var natural_width = imagedata.naturalWidth;
        // console.log('Alkuperäisen kuvan leveys', natural_width);
        // Alkuperäisen kuvan korkeus
        var natural_height = imagedata.naturalHeight;
        // console.log('Alkuperäisen kuvan korkeus', natural_height);

        var error = 0;
        var max_width_cm, max_height_cm;

        // Leveyssuuntainen kuva:
        if (cropper_width >= cropper_height) {
            max_width_cm = Math.round((cropper_width/natural_width)*max_width);
            max_height_cm = Math.round(max_width_cm/(wall_width/wall_height));
            if (max_height_cm > max_height) {
                max_height_cm = max_height;
            }
        }
        // Pystysuuntainen kuva:
        else {
            max_height_cm = Math.round((cropper_height/natural_height)*max_height);
            max_width_cm = Math.round(max_height_cm/(wall_height/wall_width));
            if (max_width_cm > max_width) {
                max_width_cm = max_width;
            }
        }

        // console.log('Laskettu maksimileveys', max_width_cm);
        // console.log('Laskettu maksimikorkeus', max_height_cm);

        if (max_width_cm < wall_width) {
            cropperData.wallWidth.parent().addClass('has-error')
            error = 1;
        } else {
            cropperData.wallWidth.parent().removeClass('has-error')
        }

        if (max_height_cm < wall_height) {
            cropperData.wallHeight.parent().addClass('has-error')
            error = 1;
        } else {
            cropperData.wallHeight.parent().removeClass('has-error')
        }
        
        if (error == 1) {
            $("#max_width_error").show();
            $('.cropper-source').addClass('has-error');
            $('#addToCart').addClass('disabled');
        } else {
            $("#max_width_error").hide();
            $('.cropper-source').removeClass('has-error');
            $('#addToCart').removeClass('disabled');
            $('.add-to-cart').find('.size-error').remove();
        }
    }

    $('.add-to-cart').on('click', '#addToCart.disabled', function(e) {
        e.preventDefault();
        $add_to_cart_el = $('.add-to-cart');
        $add_to_cart_el.find('.size-error').remove();
        $add_to_cart_el.prepend('<p class="help-block size-error text-danger small">Pienennä tapetin kokoa tai suurenna kuvan rajausta.</p>');
    });

});
